import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, { FC, useState, useEffect, useContext } from 'react'
import { BallTriangle } from 'react-loader-spinner';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Context } from '../..';
import DocumentsService from '../../services/DocumentsService';
import { ModalPopover } from './modal/modal-popover';
import {EditRecommendationsModal} from "./modal/EditRecommendationsModal";


const Recommendation: FC<any> = observer(({ rec, nos, setDelModal, setDelId }) => {
    const { store } = useContext(Context);
    const navigate = useNavigate();
    const [focus, setFocus] = useState(false);
    const [editModal, setEditModal] = useState(false);

    return (
        <tr style={{cursor:'pointer'}} className={focus ? "text-primary" : ""} onMouseEnter={() => setFocus(true)} onMouseLeave={() => setFocus(false)}>
            <td onClick={() => navigate(`/specialist/recs/${nos}/${rec['id']}`)}>{rec['name']}</td>
            <td>{store.user.is_superuser ?
                <div>
                    <i className='icon admin ms-3' onClick={() => {
                        setEditModal(true);
                    }} />
                    <i className='icon trash ms-3' onClick={() => {
                        setDelId(rec['id']);
                        setDelModal(true);
                    }} />
                    <EditRecommendationsModal data={rec} toggle={editModal} setToggle={setEditModal} />
                </div>
                : null}</td>
        </tr>
    )
});


const ForSpecialistsRecsNos: FC = () => {
    const { nos } = useParams();
    const { store } = useContext(Context)
    const [recommendations, setRecommendations] = useState([]);
    const [delId, setDelId] = useState<number>(-1);
    const [delModal, setDelModal] = useState<boolean>(false);
    const [fix, setFix] = useState<boolean>(false);
    const [sort, setSort] = useState<boolean>(true);
    const [sortFix, setSortFix] = useState<boolean>(false);
    const [loader, setLoader] = useState<boolean>(false);
    const navigate = useNavigate();


    const getAllRecommendations = async () => {
        const res = await DocumentsService.getAllRecommendationsByType('2', String(nos));
        setRecommendations(res.data.results.sort((a: any, b: any) => b.id - a.id));
        setLoader(false);
    }

    useEffect(() => {
        setLoader(true);
        getAllRecommendations();
        setFix(false);
    }, [fix]);

    useEffect(() => {
        if (sort) {
            setRecommendations(recommendations.sort((a: any, b: any) => b.id - a.id))
        } else {
            setRecommendations(recommendations.sort((a: any, b: any) => a.id - b.id))
        }
        setSortFix(false)
    }, [sortFix]);

    const getElemenets = () =>
        recommendations.map((rec: any, i: number) => {
            return <Recommendation key={i} {...{ rec, nos, i, setDelModal, setDelId }} />
        });



    const deleteRec = async () => {
        await DocumentsService.removeRecommendation(delId);
        setFix(true);
        setDelModal(false);
        setDelId(-1);
    };

    return (loader ? <div className='row justify-content-center'><div className='col-md-2 mt-5'><BallTriangle color="#1d7ea7" height={90} width={90} /></div></div> :
        <div className="m-3">
            <div>
                <Link to="/specialist/recs"><button className="btn btn-light" ><i className="icon arrow-left"></i><Trans>Back</Trans></button></Link>
            </div>
            <table className="table">
                <tbody>
                    <tr className="text-end">
                        <td colSpan={2}>
                            <button className="btn btn-light" onClick={() => {
                                setSort(!sort)
                                setSortFix(true)
                            }}>
                                {sort ? <Trans>New ones first</Trans> : <Trans>Old ones first</Trans>}
                            </button>
                        </td>
                    </tr>
                    {getElemenets()}
                </tbody>
            </table>

            <ModalPopover
                toggle={delModal}
                setToggle={setDelModal}
                title={store.lang === 'ba' ? 'Тәҡдимде алып ташлау' : store.lang === 'ru' ? 'Удаление рекомендации' : 'Deleting a recommendation'}
                modalContent={<Trans>Do you want to delete a recommendation?</Trans>}
                clickedButtonOne={() => deleteRec()}
                clickedButtonTwo={() => { setDelModal(false); setDelId(-1); }}
                ButtonOneValue={store.lang === 'ba' ? 'Эйе' : store.lang === 'ru' ? 'Да' : 'Yes'}
                ButtonTwoValue={store.lang === 'ba' ? 'Кире ҡайтарыу' : store.lang === 'ru' ? 'Отмена' : 'Cancel'}
            />
        </div>
    );
};

export default observer(ForSpecialistsRecsNos);